/*
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { ModuleWithProviders, NgModule } from '@angular/core';

import { EL_DATE_SERVICE_OPTIONS, ElDateService } from '@endlessjs/theme';
import { ElDateFnsOptions, ElDateFnsDateService } from './services/date-fns-date.service';

const dateFnsServiceProvider = { provide: ElDateService, useClass: ElDateFnsDateService };

@NgModule({
  providers: [dateFnsServiceProvider],
})
export class ElDateFnsDateModule {
  static forRoot(options: Partial<ElDateFnsOptions>): ModuleWithProviders {
    return {
      ngModule: ElDateFnsDateModule,
      providers: [
        dateFnsServiceProvider,
        { provide: EL_DATE_SERVICE_OPTIONS, useValue: options },
      ],
    };
  }

  static forChild(options: Partial<ElDateFnsOptions>): ModuleWithProviders {
    return {
      ngModule: ElDateFnsDateModule,
      providers: [
        dateFnsServiceProvider,
        { provide: EL_DATE_SERVICE_OPTIONS, useValue: options },
      ],
    };
  }
}
